module.exports = "<p-tree [style]=\"{'width':'250px','height':'500px'}\"  [value]=\"user_group\" selectionMode=\"single\" [(selection)]=\"selectedGroup\"  (onNodeSelect)=\"onNodeSelect($event)\"></p-tree>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/user_tree.component.html
// module id = ./src/app/component/user_tree.component.html
// module chunks = main